/* SPOTEC PLP — Collection & Search: filter, urutkan, muat lebih banyak tanpa pindah halaman. */
(() => {
  if (customElements.get('spx-plp')) return;

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  class SpxPlp extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.pageSize = parseInt(this.dataset.pageSize, 10) || 16;
      this.abort = new AbortController();
      const on = (el, type, fn, opts = {}) => el && el.addEventListener(type, fn, { ...opts, signal: this.abort.signal });

      on(this, 'click', (e) => this.onClick(e));
      on(this, 'change', (e) => this.onChange(e));
      on(this, 'input', (e) => {
        // Harga tidak dikirim saat masih mengetik (di iPhone keyboard bisa tertutup); dikirim saat selesai (change / Enter)
        if (e.target.matches('[data-plp-q]')) this.toggleClear();
      });
      on(this, 'submit', (e) => {
        if (!e.target.matches('[data-plp-form]')) return;
        e.preventDefault();
        this.queue(0);
      });
      on(document, 'keydown', (e) => {
        if (!this.drawerOpen) return;
        if (e.key === 'Escape') return this.setDrawer(false);
        if (e.key === 'Tab') this.trapFocus(e);
      });
      on(window, 'popstate', () => this.render(location.href, false));
      on(window, 'scroll', () => this.stickyTop(), { passive: true });
      on(window, 'resize', () => this.stickyTop(), { passive: true });

      this.stickyTop();
      this.syncSort();
      // HP: geser baris kategori supaya chip yang aktif langsung terlihat
      const cur = this.querySelector('.spx-cats .spx-cat[aria-current]');
      if (cur) {
        const row = cur.parentElement;
        const delta = cur.getBoundingClientRect().left - row.getBoundingClientRect().left - (parseFloat(getComputedStyle(row).paddingLeft) || 0);
        if (row.scrollWidth > row.clientWidth && delta > 0) row.scrollLeft += delta;
      }
      this.updateMore();
      this.updateBadge();
      this.toggleClear();
      this.loadAllSorted();
    }

    /* Urutan untuk collection > 250 produk: ambil semua halaman, lalu yang tersedia dulu (terbaru di atas), sold out di belakang.
       data-release = "1"/"0" (tersedia) + YYYYMMDD. */
    async loadAllSorted() {
      // Token dinaikkan paling awal: urutan/filter baru langsung membatalkan proses lama (juga kalau grid baru tidak memakai urutan rilis)
      const token = (this.sortToken = (this.sortToken || 0) + 1);
      this.loadingAll = false;
      const grid = this.querySelector('[data-plp-grid][data-plp-release]');
      if (!grid) return;
      const alive = () => token === this.sortToken && grid.isConnected;
      const perModel = this.dataset.unit === 'model';
      // Jumlah kartu yang terlihat sekarang (halaman pertama); kartu dari halaman berikutnya masuk tersembunyi
      const shown = Math.max(this.pageSize, this.items().filter((i) => !i.hidden).length);
      let next = this.querySelector('[data-plp-next]');
      if (next) { grid.setAttribute('aria-busy', 'true'); this.loadingAll = true; }
      try {
        let guard = 0;
        while (next && guard++ < 12) {
          const url = new URL(next.href, location.origin);
          url.searchParams.set('section_id', this.sectionId);
          const res = await fetch(url, { signal: this.controller?.signal });
          if (!res.ok || !alive()) break;
          const doc = parse(await res.text());
          if (!alive()) break;
          const byKey = new Map(this.items().map((i) => [i.dataset.key, i]));
          const ids = new Set(this.items().map((i) => i.dataset.id));
          doc.querySelectorAll('[data-plp-grid] [data-plp-item]').forEach((item) => {
            if (perModel && byKey.has(item.dataset.key)) {
              // Model sama di halaman lain: pakai kartu dengan warna yang lebih baik (tersedia / lebih baru) — gambar & link ikut
              const ex = byKey.get(item.dataset.key);
              if ((item.dataset.release || '') > (ex.dataset.release || '')) {
                item.hidden = ex.hidden;
                ex.replaceWith(item);
                byKey.set(item.dataset.key, item);
              }
              return;
            }
            if (!perModel && ids.has(item.dataset.id)) return;
            item.hidden = true;
            grid.append(item);
            byKey.set(item.dataset.key, item);
            ids.add(item.dataset.id);
          });
          const newNext = doc.querySelector('[data-plp-next]');
          if (newNext) next.href = newNext.href; else { next.remove(); next = null; }
        }
      } catch (err) {
        if (err.name !== 'AbortError') console.warn('SPOTEC: could not load all products for release order', err);
      }
      if (!alive()) return;
      this.loadingAll = false;
      const items = this.items();
      items
        .map((el, i) => ({ el, i, r: el.dataset.release || '000000000' }))
        .sort((a, b) => (a.r === b.r ? a.i - b.i : a.r < b.r ? 1 : -1))
        .forEach(({ el }, i) => { grid.append(el); el.hidden = i >= shown; });
      grid.removeAttribute('aria-busy');
      this.updateMore();
    }

    disconnectedCallback() {
      this.abort?.abort();
      document.documentElement.classList.remove('spx-lock');
    }

    get form() { return this.querySelector('[data-plp-form]'); }
    get drawer() { return this.querySelector('[data-plp-drawer]'); }
    get overlay() { return this.querySelector('[data-plp-overlay]'); }

    /* Toolbar menempel tepat di bawah header (header bisa naik-turun). */
    stickyTop() {
      if (this.stickyFrame) return;
      this.stickyFrame = requestAnimationFrame(() => {
        this.stickyFrame = null;
        const header = document.querySelector('.sf-header-section, .shopify-section-group-header-group, .section-header');
        let top = 0;
        if (header) {
          const pos = getComputedStyle(header).position;
          if (pos === 'sticky' || pos === 'fixed') top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        }
        this.style.setProperty('--spx-sticky-top', top + 'px');
      });
    }

    onClick(e) {
      const t = e.target.closest('button, a');
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute('data-plp-open')) { e.preventDefault(); return this.setDrawer(true); }
      if (t.hasAttribute('data-plp-close')) { e.preventDefault(); return this.setDrawer(false); }
      if (t.hasAttribute('data-plp-load')) { e.preventDefault(); return this.loadMore(); }
      if (t.hasAttribute('data-plp-clear')) {
        e.preventDefault();
        const q = this.querySelector('[data-plp-q]');
        if (q) { q.value = ''; q.focus(); this.toggleClear(); }
        return;
      }
      if (t.matches('a[data-plp-link]')) { e.preventDefault(); return this.render(t.href, true); }
    }

    onChange(e) {
      const t = e.target;
      if (t.matches('[data-plp-sort]')) { this.syncSort(); return this.queue(0); }
      if (t.closest('[data-plp-form]') && t.type === 'checkbox') {
        t.closest('.spx-opt')?.classList.toggle('is-active', t.checked);
        return this.queue(150);
      }
      if (t.matches('[data-plp-price]')) return this.queue(0);
    }

    queue(delay) {
      clearTimeout(this.timer);
      // A newer change is coming: drop the older request so its answer can't overwrite what the user just typed/ticked
      this.controller?.abort();
      this.timer = setTimeout(() => this.submit(), delay);
    }

    submit() {
      const form = this.form;
      if (!form) return;
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(form)) {
        if (v === '' || v == null) continue;
        params.append(k, v);
      }
      const url = form.getAttribute('action').split('?')[0] + '?' + params.toString();
      this.render(url, true);
    }

    async render(url, push) {
      const target = new URL(url, location.origin);
      const fetchUrl = new URL(target);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      this.classList.add('is-loading');
      this.controller?.abort();
      const ctrl = new AbortController();
      this.controller = ctrl;
      try {
        const res = await fetch(fetchUrl, { signal: ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = parse(await res.text());
        const fresh = doc.querySelector('spx-plp');
        if (!fresh) throw new Error('no section');
        this.swap(fresh);
        if (push) history.pushState({ spx: true }, '', target.pathname + target.search);
      } catch (err) {
        if (err.name !== 'AbortError') location.href = target.href;
      } finally {
        // An older, cancelled request must not hide the spinner of the newer one
        if (this.controller === ctrl) this.classList.remove('is-loading');
      }
    }

    swap(fresh) {
      const replace = (sel) => {
        const now = this.querySelectorAll(sel);
        const next = fresh.querySelectorAll(sel);
        now.forEach((el, i) => { if (next[i]) el.replaceWith(next[i]); });
      };
      // Ingat elemen yang sedang fokus (checkbox / input harga) supaya fokus kembali ke tempat yang sama.
      const active = document.activeElement;
      const focusKey = active && this.contains(active) && active.name
        ? { name: active.name, value: active.type === 'checkbox' ? active.value : null }
        : null;
      const focusWasPill = active && this.contains(active) && active.matches('.spx-pill');
      const typedPrice = active && this.contains(active) && active.matches('[data-plp-price]') ? active.value : null;

      // Simpan grup filter yang terbuka + posisi scroll panel.
      const openIds = [...this.querySelectorAll('.spx-fg[open]')].map((d) => d.id);
      const closedIds = [...this.querySelectorAll('.spx-fg:not([open])')].map((d) => d.id);
      const body = this.querySelector('.spx-dr__body');
      const scroll = body ? body.scrollTop : 0;

      replace('[data-plp-results]');
      replace('[data-plp-active]');
      const filters = this.querySelector('[data-plp-filters]');
      const freshFilters = fresh.querySelector('[data-plp-filters]');
      if (filters && freshFilters) filters.innerHTML = freshFilters.innerHTML;
      this.querySelectorAll('[data-plp-count]').forEach((el) => {
        const src = fresh.querySelector('[data-plp-count]');
        if (src) el.textContent = src.textContent;
      });
      const reset = this.querySelector('.spx-dr__foot a[data-plp-link]');
      const freshReset = fresh.querySelector('.spx-dr__foot a[data-plp-link]');
      if (reset && freshReset) reset.href = freshReset.getAttribute('href');
      const sort = this.querySelector('[data-plp-sort]');
      const freshSort = fresh.querySelector('[data-plp-sort]');
      if (sort && freshSort) sort.value = freshSort.value;
      this.syncSort();

      openIds.forEach((id) => this.querySelector('#' + CSS.escape(id))?.setAttribute('open', ''));
      closedIds.forEach((id) => this.querySelector('#' + CSS.escape(id))?.removeAttribute('open'));
      if (body) body.scrollTop = scroll;

      if (focusKey) {
        const sel = `[name="${CSS.escape(focusKey.name)}"]` + (focusKey.value != null ? `[value="${CSS.escape(focusKey.value)}"]` : '');
        const again = this.querySelector(sel);
        if (again && typedPrice != null) again.value = typedPrice;
        again?.focus({ preventScroll: true });
      } else if (focusWasPill) {
        (this.querySelector('.spx-pill') || this.querySelector('[data-plp-open]') || this.querySelector('[data-plp-sort]'))?.focus({ preventScroll: true });
      }

      this.updateMore();
      this.updateBadge();
      this.loadAllSorted();
      // Filter/urutan diganti dari bawah daftar panjang: kembali ke atas hasil, bukan terlempar ke footer
      const results = this.querySelector('[data-plp-results]');
      const bar = this.querySelector('[data-plp-bar]');
      if (results) {
        const offset = bar ? bar.getBoundingClientRect().bottom : 0;
        const top = results.getBoundingClientRect().top;
        if (top < offset) window.scrollTo({ top: Math.max(0, window.scrollY + top - offset - 8), behavior: 'auto' });
      }
    }

    // Tulisan pilihan urutan yang terlihat (dropdown asli transparan di atasnya)
    syncSort() {
      const sort = this.querySelector('[data-plp-sort]');
      const text = this.querySelector('[data-plp-sort-text]');
      if (sort && text && sort.selectedIndex >= 0) text.textContent = sort.options[sort.selectedIndex].text;
    }

    trapFocus(e) {
      const dr = this.drawer;
      if (!dr) return;
      const focusables = [...dr.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, summary, [tabindex]:not([tabindex="-1"])')]
        .filter((el) => el.offsetParent !== null || el === document.activeElement);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dr.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !dr.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }

    setDrawer(open) {
      const dr = this.drawer;
      const ov = this.overlay;
      if (!dr) return;
      this.drawerOpen = open;
      clearTimeout(this.drawerTimer);
      this.querySelectorAll('[data-plp-open]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
      if (open) {
        this.lastFocus = document.activeElement;
        dr.hidden = false;
        if (ov) ov.hidden = false;
        document.documentElement.classList.add('spx-lock');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          dr.classList.add('is-open');
          ov?.classList.add('is-open');
          dr.querySelector('[data-plp-close]')?.focus({ preventScroll: true });
        }));
        if (ov && !ov.dataset.bound) { ov.dataset.bound = '1'; ov.addEventListener('click', () => this.setDrawer(false)); }
      } else {
        dr.classList.remove('is-open');
        ov?.classList.remove('is-open');
        document.documentElement.classList.remove('spx-lock');
        this.drawerTimer = setTimeout(() => { dr.hidden = true; if (ov) ov.hidden = true; }, 320);
        this.lastFocus?.focus?.({ preventScroll: true });
      }
    }

    items() { return [...this.querySelectorAll('[data-plp-grid] [data-plp-item]')]; }

    updateMore() {
      const more = this.querySelector('[data-plp-more]');
      if (!more) return;
      const items = this.items();
      const shown = items.filter((i) => !i.hidden).length;
      const next = more.querySelector('[data-plp-next]');
      const text = more.querySelector('[data-plp-more-text]');
      const prog = more.querySelector('[data-plp-prog]');
      const btn = more.querySelector('[data-plp-load]');
      const unit = this.dataset.unit === 'model' ? 'models' : 'products';
      if (text) text.textContent = `Showing ${shown} of ${items.length}${next ? '+' : ''} ${unit}`;
      if (prog) prog.style.width = (items.length ? (shown / items.length) * 100 : 0) + '%';
      if (btn) btn.hidden = shown >= items.length && !next;
      more.hidden = items.length <= this.pageSize && !next;
      // Semua produk di sini belum punya foto → tampilkan pesan, bukan halaman kosong
      const grid = this.querySelector('[data-plp-grid]');
      const busy = grid && grid.hasAttribute('aria-busy');
      let empty = this.querySelector('[data-plp-empty]');
      if (grid && !items.length && !next && !busy) {
        if (!empty) {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          empty = document.createElement('div');
          empty.className = 'spx-empty';
          empty.setAttribute('data-plp-empty', '');
          empty.innerHTML = '<h2>No products here yet</h2><p>Products for this category are coming soon. Browse another category in the meantime.</p>';
          const a = document.createElement('a');
          a.className = 'spx-btn spx-btn--line';
          a.href = root + 'collections/all';
          a.textContent = 'View all products';
          empty.append(a);
          grid.after(empty);
        }
        more.hidden = true;
      } else if (empty) {
        empty.remove();
      }
    }

    async loadMore() {
      const hiddenItems = this.items().filter((i) => i.hidden);
      if (hiddenItems.length) {
        hiddenItems.slice(0, this.pageSize).forEach((item, i) => {
          item.hidden = false;
          item.classList.add('is-revealed');
          item.style.animationDelay = Math.min(i, 8) * 30 + 'ms';
        });
        return this.updateMore();
      }
      // Lebih dari 250 produk: ambil halaman berikutnya (kecuali sedang diambil semua untuk urutan rilis).
      const next = this.querySelector('[data-plp-next]');
      if (!next || this.loadingMore || this.loadingAll) return;
      const grid = this.querySelector('[data-plp-grid]');
      this.loadingMore = true;
      const btn = this.querySelector('[data-plp-load]');
      btn?.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(next.href, location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        const doc = parse(await res.text());
        if (!grid || !grid.isConnected) return; // filter/urutan berubah saat memuat → jangan campur hasil lama
        // One card per model: skip models already shown on the first page. Per product: keep everything.
        const perModel = this.dataset.unit === 'model';
        const keys = new Set(this.items().map((i) => i.dataset.key));
        const ids = new Set(this.items().map((i) => i.dataset.id));
        const incoming = [...doc.querySelectorAll('[data-plp-grid] [data-plp-item]')].filter((i) => (perModel ? !keys.has(i.dataset.key) : !ids.has(i.dataset.id)));
        incoming.forEach((item, i) => {
          item.hidden = i >= this.pageSize;
          if (!item.hidden) item.classList.add('is-revealed');
          grid.append(item);
        });
        const newNext = doc.querySelector('[data-plp-next]');
        if (newNext) next.href = newNext.href; else next.remove();
      } catch (err) {
        // Keep the "next" link so the button can simply be pressed again
        console.warn('SPOTEC: could not load more products', err);
      } finally {
        this.loadingMore = false;
        btn?.removeAttribute('aria-busy');
        this.updateMore();
      }
    }

    updateBadge() {
      const active = this.querySelector('[data-plp-active]');
      const n = active ? parseInt(active.dataset.activeCount, 10) || 0 : 0;
      this.querySelectorAll('[data-plp-open]').forEach((btn) => {
        let badge = btn.querySelector('.spx-bar__badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'spx-bar__badge';
          btn.append(badge);
        }
        badge.textContent = n;
        badge.hidden = n === 0;
      });
    }

    toggleClear() {
      const q = this.querySelector('[data-plp-q]');
      const clear = this.querySelector('[data-plp-clear]');
      if (q && clear) clear.hidden = !q.value;
    }
  }

  customElements.define('spx-plp', SpxPlp);
})();
